<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-traffic-cone`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_01b00f367a__clip0_0:3252)"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.776 5.691A1 1 0 0118.727 5h10.546a1 1 0 01.951.691L40.703 38H44a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2a1 1 0 011-1h3.297L17.776 5.691zM11.55 38h24.9l-1.93-6H13.48l-1.93 6zm3.218-10h18.464l-2.253-7H17.021l-2.253 7zm3.54-11l2.575-8h6.234l2.575 8H18.308z"/></g><defs><clipPath id="svg_01b00f367a__clip0_0:3252"><path d="M0 0h48v48H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconTrafficCone',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
